/**
 * Världskartan i hero på referenssidan.
 *
 * Markup: resources/views/components/world-map.blade.php
 * Stil:   resources/css/style.css
 *
 *  - Varje ort är en <button class="hm-world__pin"> med data-tooltip (kort namn)
 *    och data-detail (längre förtydligande, t.ex. "Mt Newman avser orten Newman").
 *  - Tooltipen följer muspekaren och tangentbordsfokus.
 *  - Ortväljaren och infotexten är valfria. Under 40rem döljs de med CSS, så
 *    koden nedan får aldrig utgå från att de finns.
 */
function initWorldMap() {
    document.querySelectorAll('.hm-world').forEach((root) => {
        if (root.dataset.ready) return
        root.dataset.ready = 'true'

        const pins = [...root.querySelectorAll('.hm-world__pin')]
        const select = root.querySelector('select')
        const info = root.querySelector('.hm-world__info')
        const tooltip = root.querySelector('.hm-world__tooltip')

        // Markera vald ort och skriv ut dess förtydligande.
        function choose(value) {
            pins.forEach((pin, i) => {
                pin.setAttribute('aria-pressed', String(String(i) === value))
            })
            if (select) select.value = value
            if (info) {
                info.textContent =
                    value === '' ? '' : pins[Number(value)].dataset.detail
            }
        }

        // Håll tooltipen nära pekaren, men innanför fönstret.
        function placeTooltip(x, y) {
            const half = Math.min(140, tooltip.offsetWidth / 2)
            tooltip.style.left = `${Math.max(12 + half, Math.min(window.innerWidth - 12 - half, x))}px`
            tooltip.style.top = `${Math.max(42, y)}px`
        }

        function showTooltip(pin, event) {
            const rect = pin.getBoundingClientRect()
            tooltip.textContent = pin.dataset.tooltip
            tooltip.setAttribute('aria-hidden', 'false')
            placeTooltip(
                event && event.clientX
                    ? event.clientX
                    : rect.left + rect.width / 2,
                event && event.clientY ? event.clientY : rect.top
            )
            requestAnimationFrame(() => {
                tooltip.dataset.show = 'true'
            })
        }

        function hideTooltip() {
            tooltip.dataset.show = 'false'
            tooltip.setAttribute('aria-hidden', 'true')
        }

        pins.forEach((pin, i) => {
            pin.addEventListener('click', () => choose(String(i)))
            pin.addEventListener('pointerenter', (event) =>
                showTooltip(pin, event)
            )
            pin.addEventListener('pointermove', (event) =>
                placeTooltip(event.clientX, event.clientY)
            )
            pin.addEventListener('pointerleave', hideTooltip)
            pin.addEventListener('focus', () => showTooltip(pin))
            pin.addEventListener('blur', hideTooltip)
        })

        if (select) {
            select.addEventListener('change', () => choose(select.value))
        }

        root.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') choose('')
        })
    })
}

export default initWorldMap
